module.exports = __webpack_public_path__ + "static/media/cf.8cc39dd4.svg";